module.exports = __webpack_public_path__ + "img/growthAbility3.65feee3a.png";